import { useEffect } from "react";

const setIsAfterPayLoadedList = [];
export const useAfterPayInjectionScript = (setIsAfterPayLoaded) => {
    useEffect(() => {

        // Return if AfterPaySDK is already injected.
        if(window.jostensAfterPay?.isReady) {
            setIsAfterPayLoaded && setIsAfterPayLoaded(true);
            return;
        } else {
            setIsAfterPayLoaded && setIsAfterPayLoadedList.push(setIsAfterPayLoaded);
        }
        if (document.querySelector('#afterpay-message-script')) {
            return;
        }

        const afterPayScriptElement = document.createElement('script');
        let srcUrlPrefix = window.location.hostname === 'localhost' ? 'http://localhost:8080' : '';
        afterPayScriptElement.src = srcUrlPrefix + '/apps/jcom/s4/src/component/afterpay-message/afterpay-message.js';
        afterPayScriptElement.setAttribute("data-ot-ignore", "data-ot-ignore");
        afterPayScriptElement.setAttribute("id", "afterpay-message-script");
        afterPayScriptElement.setAttribute("type", "text/javascript");
        afterPayScriptElement.onload = () => {
            window.jostensAfterPay.subscribe(() => {
                setIsAfterPayLoadedList.forEach(setIsAfterPayLoaded => {
                    setIsAfterPayLoaded(true)
                });
            });
        }
        afterPayScriptElement.onerror = () => {
            setIsAfterPayLoadedList.forEach(setIsAfterPayLoaded => {
                setIsAfterPayLoaded(true)
            });
        }

        document.head.appendChild(afterPayScriptElement);
    }, []);
}